"use strict";

var _regeneratorRuntime = require("/var/www/prod/lucky1/lucky-one-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/var/www/prod/lucky1/lucky-one-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/var/www/prod/lucky1/lucky-one-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/www/prod/lucky1/lucky-one-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/var/www/prod/lucky1/lucky-one-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/var/www/prod/lucky1/lucky-one-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BufferTokenizer = void 0;

var peek_readable_1 = require("peek-readable");

var AbstractTokenizer_1 = require("./AbstractTokenizer");

var BufferTokenizer = /*#__PURE__*/function (_AbstractTokenizer_1$) {
  _inherits(BufferTokenizer, _AbstractTokenizer_1$);

  var _super = _createSuper(BufferTokenizer);

  /**
   * Construct BufferTokenizer
   * @param uint8Array - Uint8Array to tokenize
   * @param fileInfo - Pass additional file information to the tokenizer
   */
  function BufferTokenizer(uint8Array, fileInfo) {
    var _this;

    _classCallCheck(this, BufferTokenizer);

    _this = _super.call(this, fileInfo);
    _this.uint8Array = uint8Array;
    _this.fileInfo.size = _this.fileInfo.size ? _this.fileInfo.size : uint8Array.length;
    return _this;
  }
  /**
   * Read buffer from tokenizer
   * @param uint8Array - Uint8Array to tokenize
   * @param options - Read behaviour options
   * @returns {Promise<number>}
   */


  _createClass(BufferTokenizer, [{
    key: "readBuffer",
    value: function () {
      var _readBuffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(uint8Array, options) {
        var bytesRead;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(options && options.position)) {
                  _context.next = 4;
                  break;
                }

                if (!(options.position < this.position)) {
                  _context.next = 3;
                  break;
                }

                throw new Error('`options.position` must be equal or greater than `tokenizer.position`');

              case 3:
                this.position = options.position;

              case 4:
                _context.next = 6;
                return this.peekBuffer(uint8Array, options);

              case 6:
                bytesRead = _context.sent;
                this.position += bytesRead;
                return _context.abrupt("return", bytesRead);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function readBuffer(_x, _x2) {
        return _readBuffer.apply(this, arguments);
      }

      return readBuffer;
    }()
    /**
     * Peek (read ahead) buffer from tokenizer
     * @param uint8Array
     * @param options - Read behaviour options
     * @returns {Promise<number>}
     */

  }, {
    key: "peekBuffer",
    value: function () {
      var _peekBuffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(uint8Array, options) {
        var normOptions, bytes2read;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                normOptions = this.normalizeOptions(uint8Array, options);
                bytes2read = Math.min(this.uint8Array.length - normOptions.position, normOptions.length);

                if (!(!normOptions.mayBeLess && bytes2read < normOptions.length)) {
                  _context2.next = 6;
                  break;
                }

                throw new peek_readable_1.EndOfStreamError();

              case 6:
                uint8Array.set(this.uint8Array.subarray(normOptions.position, normOptions.position + bytes2read), normOptions.offset);
                return _context2.abrupt("return", bytes2read);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function peekBuffer(_x3, _x4) {
        return _peekBuffer.apply(this, arguments);
      }

      return peekBuffer;
    }()
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }]);

  return BufferTokenizer;
}(AbstractTokenizer_1.AbstractTokenizer);

exports.BufferTokenizer = BufferTokenizer;